import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { MobileActionBar } from "@/components/MobileActionBar";
import Home from "@/pages/Home";
import BrakeReplacement from "@/pages/BrakeReplacement";
import Services from "@/pages/Services";
import ServiceAreas from "@/pages/ServiceAreas";
import LocationPage from "@/pages/LocationPage";
import ReviewsPage from "@/pages/ReviewsPage";
import QuotePage from "@/pages/QuotePage";
import { WarrantyPage, PrivacyPage, TermsPage } from "@/pages/Legal";
import AdminQuotes from "@/pages/AdminQuotes";
import ServicePage from "@/pages/ServicePage";
import { SERVICE_PAGES } from "@/data/services";
import NotFound from "@/pages/NotFound";
import { LOCATIONS } from "@/data/locations";


function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function useLenis() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.12, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
}

function Shell() {
  useLenis();
  return (
    <div className="min-h-screen bg-obsidian">
      <ScrollToTop />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/brake-replacement" element={<BrakeReplacement />} />
          <Route path="/services" element={<Services />} />
          <Route path="/service-areas" element={<ServiceAreas />} />
          <Route path="/reviews" element={<ReviewsPage />} />
          <Route path="/get-a-brake-quote" element={<QuotePage />} />
          {SERVICE_PAGES.map((s) => (
            <Route key={s.slug} path={`/${s.slug}`} element={<ServicePage service={s} />} />
          ))}
          <Route path="/admin" element={<AdminQuotes />} />
          <Route path="/warranty" element={<WarrantyPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          {LOCATIONS.map((l) => (
            <Route key={l.slug} path={`/${l.slug}`} element={<LocationPage />} />
          ))}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <MobileActionBar />
      <Toaster position="top-center" richColors />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Shell />
    </BrowserRouter>
  );
}

export default App;
